/** Nord-opp kompassrose med kursnål. cog = grader (0=N, med klokka) eller null. */
export function CompassRose({
  cog,
  className = 'w-full max-w-[200px] mx-auto block',
}: {
  cog: number | null;
  className?: string;
}) {
  const ticks = [];
  for (let d = 0; d < 360; d += 10) {
    const major = d % 30 === 0;
    const rad = (d * Math.PI) / 180;
    const sx = Math.sin(rad);
    const cy = -Math.cos(rad);
    const r1 = 100;
    const r2 = major ? 84 : 92;
    ticks.push(
      <line
        key={d}
        x1={r1 * sx}
        y1={r1 * cy}
        x2={r2 * sx}
        y2={r2 * cy}
        stroke={major ? '#94a3b8' : '#475569'}
        strokeWidth={major ? 2 : 1}
      />,
    );
  }

  const cardinals: Array<[string, number]> = [
    ['N', 0],
    ['Ø', 90],
    ['S', 180],
    ['V', 270],
  ];

  return (
    <svg viewBox="-115 -115 230 230" className={className}>
      <circle cx="0" cy="0" r="100" fill="none" stroke="#334155" strokeWidth="2" />
      {ticks}
      {cardinals.map(([label, d]) => {
        const rad = (d * Math.PI) / 180;
        const x = 70 * Math.sin(rad);
        const y = -70 * Math.cos(rad);
        return (
          <text
            key={label}
            x={x}
            y={y}
            textAnchor="middle"
            dominantBaseline="central"
            fontSize="20"
            fontWeight="bold"
            fill={label === 'N' ? '#f87171' : '#cbd5e1'}
          >
            {label}
          </text>
        );
      })}
      {cog !== null && (
        <g transform={`rotate(${cog})`}>
          <polygon points="0,-88 9,0 0,-16 -9,0" fill="#34d399" />
          <polygon points="0,88 6,0 0,16 -6,0" fill="#475569" />
        </g>
      )}
      <circle cx="0" cy="0" r="6" fill="#0ea5e9" stroke="#0b1220" strokeWidth="2" />
    </svg>
  );
}
